import styled from "styled-components";

const ModalHeader = styled.div `
  position: relative;
  padding: 1.35rem 3.9rem 1.35rem 1.9rem;
  border-bottom: 2px solid #f3f3f3;
`;

export default ModalHeader;
